<script>
    import BarChart from "../../shared/BarChart.svelte";
    import Link from "../../shared/Link.svelte";
    import { _ } from "svelte-i18n";

    import bar1 from "../../stores/Bar_L9_1.js";
    import bar2 from "../../stores/Bar_L9_2.js";
    import bar3 from "../../stores/Bar_L9_3.js";
    import bar4 from "../../stores/Bar_L9_4.js";
    import bar5 from "../../stores/Bar_L9_5.js";
    import bar6 from "../../stores/Bar_L9_6.js";
    import bar7 from "../../stores/Bar_L9_7.js";
    import bar8 from "../../stores/Bar_L9_8.js";
    import bar9 from "../../stores/Bar_L9_9.js";
    import bar10 from "../../stores/Bar_L9_10.js";
</script>

<div class="title">
  <h2>{$_("lesson-okhMZ.h2-0")}</h2>
</div>
<hr />
<div class="text">
  <p>
    {$_("lesson-okhMZ.p-0")}
  </p>
  <p>
    {$_("lesson-okhMZ.p-1")}
  </p>
  <div align="center"><img width="700" src="/img/Benchmarks.png" alt="Different sized graphs for evaluating the TSP solver, ranging from a triangle to an octagon"></div>
  <p>
    {$_("lesson-okhMZ.p-2")}
    {`$$H=\\begin{bmatrix}-8.0 & 8.0 & 8.0 & 8.0 & 0.5 & 0.5 & 8.0 & 0.5 & 0.5 \\\\ 0.0 & -8.0 & 8.0 & 0.5 & 8.0 & 0.5 & 0.5 & 8.0 & 0.5 \\\\ 0.0 & 0.0 & -8.0 & 0.5 & 0.5 & 8.0 & 0.5 & 0.5 & 8.0 \\\\ 0.0 & 0.0 & 0.0 & -8.0 & 8.0 & 8.0 & 8.0 & 0.5 & 0.5 \\\\ 0.0 & 0.0 & 0.0 & 0.0 & -8.0 & 8.0 & 0.5 & 8.0 & 0.5 \\\\ 0.0 & 0.0 & 0.0 & 0.0 & 0.0 & -8.0 & 0.5 & 0.5 & 8.0 \\\\ 0.0 & 0.0 & 0.0 & 0.0 & 0.0 & 0.0 & -8.0 & 8.0 & 8.0 \\\\ 0.0 & 0.0 & 0.0 & 0.0 & 0.0 & 0.0 & 0.0 & -8.0 & 8.0 \\\\ 0.0 & 0.0 & 0.0 & 0.0 & 0.0 & 0.0 & 0.0 & 0.0 & -8.0\\end{bmatrix}$$`}
  </p>
  <p>
    {@html $_("lesson-okhMZ.p-3")}
    {`$$\\min C_{n}\\left(q\\right)=-8n+0.5n=-7.5n$$`}
  </p>
  <p>
    {@html $_("lesson-okhMZ.p-4-0")} <Link target="https://docs.ocean.dwavesys.com/projects/system/en/stable/reference/generated/dwave.system.composites.EmbeddingComposite.sample.html#dwave.system.composites.EmbeddingComposite.sample" newPage={true}>{$_("lesson-okhMZ.Link-0")}</Link>, {@html $_("lesson-okhMZ.p-4-1")}
  </p>
  <p>
    {@html $_("lesson-okhMZ.p-5")} <Link target="https://www.fourmilab.ch/documents/travelling/anneal/" newPage={true}>{$_("lesson-okhMZ.Link-0")}</Link>.
  </p>
  <p>
    {$_("lesson-okhMZ.p-6")}
  </p>
  <div class="subtitle">Advantage</div>
  <div class="subplots">
    <BarChart
      points={bar1.points}
      yTicks={bar1.yTicks}
      yLabel={$_("lesson-okhMZ.yLabel-simple")}
      width="300"
      height="300"
      barColor="#2eb6e8"
    />
    <BarChart
      points={bar2.points}
      yTicks={bar2.yTicks}
      yLabel={$_("lesson-okhMZ.yLabel-complex")}
      width="300"
      height="300"
      barColor="#2eb6e8"
    />
  </div>
  <div class="subtitle">2000Q</div>
  <div class="subplots">
    <BarChart
      points={bar3.points}
      yTicks={bar3.yTicks}
      yLabel={$_("lesson-okhMZ.yLabel-simple")}
      width="300"
      height="300"
      barColor="#1a91bc"
    />
    <BarChart
      points={bar4.points}
      yTicks={bar4.yTicks}
      yLabel={$_("lesson-okhMZ.yLabel-complex")}
      width="300"
      height="300"
      barColor="#1a91bc"
    />
  </div>
  <div class="subtitle">Simulated Annealing</div>
  <div class="subplots">
    <BarChart
      points={bar1.points}
      yTicks={bar1.yTicks}
      yLabel={$_("lesson-okhMZ.yLabel-simple")}
      width="300"
      height="300"
      barColor="#f1b6e8"
    />
    <BarChart
      points={bar1.points}
      yTicks={bar1.yTicks}
      yLabel={$_("lesson-okhMZ.yLabel-complex")}
      width="300"
      height="300"
      barColor="#f1b6e8"
    />
  </div>
  <p>
    {$_("lesson-okhMZ.p-7")}
  </p>
  <div class="subtitle">Advantage</div>
  <div class="subplots">
    <BarChart
      points={bar5.points}
      yTicks={bar5.yTicks}
      yLabel={$_("lesson-okhMZ.yLabel-simple-ms")}
      width="300"
      height="300"
      barColor="#2eb6e8"
    />
    <BarChart
      points={bar6.points}
      yTicks={bar6.yTicks}
      yLabel={$_("lesson-okhMZ.yLabel-complex-ms")}
      width="300"
      height="300"
      barColor="#2eb6e8"
    />
  </div>
  <div class="subtitle">2000Q</div>
  <div class="subplots">
    <BarChart
      points={bar7.points}
      yTicks={bar7.yTicks}
      yLabel={$_("lesson-okhMZ.yLabel-simple-ms")}
      width="300"
      height="300"
      barColor="#1a91bc"
    />
    <BarChart
      points={bar8.points}
      yTicks={bar8.yTicks}
      yLabel={$_("lesson-okhMZ.yLabel-complex-ms")}
      width="300"
      height="300"
      barColor="#1a91bc"
    />
  </div>
  <div class="subtitle">Simulated Annealing</div>
  <div class="subplots">
    <BarChart
      points={bar9.points}
      yTicks={bar9.yTicks}
      yLabel={$_("lesson-okhMZ.yLabel-simple-ms")}
      width="300"
      height="300"
      barColor="#f1b6e8"
    />
    <BarChart
      points={bar10.points}
      yTicks={bar10.yTicks}
      yLabel={$_("lesson-okhMZ.yLabel-complex-ms")}
      width="300"
      height="300"
      barColor="#f1b6e8"
    />
  </div>
  <p>
    {@html $_("lesson-okhMZ.p-8")}
  </p>
  <p>
    {$_("lesson-okhMZ.p-9-0")} <Link target="https://github.com/Totemi1324/TSPquantum" newPage={true}>{$_("lesson-okhMZ.Link-2")}</Link> {@html $_("lesson-okhMZ.p-9-1")}.
  </p>
</div>
<hr>
<div class="refs">
  <h3>{$_("lesson-okhMZ.references")}</h3>
  <ol>
    <li><Link target="https://en.wikipedia.org/wiki/Simulated_annealing" newPage={true}>https://en.wikipedia.org/wiki/Simulated_annealing</Link>, {$_("lesson-okhMZ.ref_access")}: 12.05.2022</li>
  </ol>
</div>

<style>
  .title h2, .refs h3 {
    background: -webkit-linear-gradient(90deg, #1a91bc, #2eb6e8);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  hr {
    border: 1px solid white;
    border-top: 1px solid #ddd;
    margin: 20px auto;
  }
  .subtitle {
    color: #bbb;
    text-align: center;
    font-style: italic;
  }
  .subplots {
    display: flex;
  }
</style>